import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgInstagramLogo: React.FunctionComponent<
  SVGProps<SVGSVGElement>
> = props => (
  <svg viewBox="0 0 67 67" role="img" aria-label="Instagram" {...props}>
    <path
      d="M42.27 26.58l1.5-.01a1.22 1.22 0 0 0 1.18-1.22v-2.89c0-.69-.55-1.24-1.24-1.24h-2.88c-.69 0-1.23.55-1.23 1.25v2.86a1.23 1.23 0 0 0 1.28 1.25h1.4zM33 27.82a6.18 6.18 0 1 0 0 12.36 6.18 6.18 0 0 0 0-12.36zm-11.95 3.3v13.62c0 .65.56 1.21 1.2 1.21h21.49c.65 0 1.21-.56 1.21-1.21V31.1h-2.91a9.55 9.55 0 0 1-3.72 10.74 9.48 9.48 0 0 1-14.37-10.73h-2.9zM45.2 49.26l.48-.09a3.3 3.3 0 0 0 2.5-2.55l.08-.41V21.79l-.07-.4a3.3 3.3 0 0 0-2.78-2.61l-.17-.03H20.76a3.29 3.29 0 0 0-2.99 2.85l-.02.16v24.48l.08.47a3.3 3.3 0 0 0 2.77 2.52l.2.03h24.4zM33 64a30 30 0 1 1 0-60 30 30 0 0 1 0 60z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);
/* eslint-enable max-len */

export default SvgInstagramLogo;
